import Contact from 'features/Contact'
import React from 'react'

const ContactPage = () => {
  return (
    <div>
      <Contact />
    </div>
  )
}

export default ContactPage